import { forwardRef } from "react"
import { Link, LinkProps } from "@mui/material"
import { StyleParams, useStyles } from "./styles"

export type Props = LinkProps & StyleParams

const CustomLink = forwardRef<HTMLAnchorElement, Props>(
  (
    {
      className,
      underline = "none",
      textDecorationStyle = "solid",
      children,
      ...props
    },
    ref
  ) => {
    const { classes, cx } = useStyles({ textDecorationStyle })

    return (
      <Link
        ref={ref}
        {...props}
        underline={underline}
        className={cx(classes.customLink, className)}
      >
        {children}
      </Link>
    )
  }
)

export default CustomLink
